
export const METRIC_FILTER_SERIES = 'metric-filter-series';

export const METRIC_FILTER_COLOR = '#BD10E0';

export function buildMetricFilterSeries(data, { xAxisIndex = 0, yAxisIndex = 0, barChart = false }) {
  return {
    id: METRIC_FILTER_SERIES,
    name: 'Secondary Filter',
    data,
    type: barChart ? 'bar' : 'line',
    symbol: 'circle',
    showSymbol: false,
    showBackground: false,
    xAxisIndex,
    yAxisIndex,
    itemStyle: {
      color: METRIC_FILTER_COLOR,
    },
    lineStyle: {
      width: 1.5,
      opacity: 0.7,
    },
    areaStyle: {
      opacity: 0,
    },
    markLine: {},
    triggerLineEvent: true,
  };
}
